import '@expo/metro-runtime';
import { registerRootComponent } from 'expo';

import App from './src/app/App';

registerRootComponent(App);
